<template>
  <div>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="В работе у подчиненных"
      :visible.sync="show"
      width="90%"
      destroy-on-close
    >
      <el-row>
        <el-row class="users-filters filters-before-table" type="flex" style="margin-bottom: 32px;">
          <el-col :span="11">
            <el-input
              v-model="search"
              prefix-icon="el-icon-search"
              placeholder="Поиск"
              size="small"
              clearable
              @clear="searchChanged"
              v-debounce:500="searchChanged"
            >
            </el-input>
          </el-col>
        </el-row>
        <el-table
          v-loading="loading"
          size="mini"
          empty-text="Нет целей"
          :data="elements"
        >
          <el-table-column width="100" prop="card.id" label="ID карты"></el-table-column>
          <el-table-column width="150" prop="card.user.meta.tabnr" label="Табельный номер"></el-table-column>
          <el-table-column width="250" prop="card.user.full_name" label="ФИО"></el-table-column>
          <el-table-column prop="card.year" label="Год"></el-table-column>
          <el-table-column label="Период">
            <template v-slot="scope">
              <div>
                {{
                  $companyConfiguration.card.getAvailablePeriods()[scope.row.card.period]
                    ? $companyConfiguration.card.getAvailablePeriods()[scope.row.card.period]
                    : ''
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID цели"></el-table-column>
          <el-table-column width="200" prop="name" label="Название цели"></el-table-column>
          <el-table-column width="300" prop="desc" label="Описание цели"></el-table-column>
        </el-table>
        <paginator
          style="margin-bottom: 0"
          :paginator.sync="paginator"
          @page-changed="searchElements"
        ></paginator>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Закрыть</el-button>
      </div>
    </el-dialog>
    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>
import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import requestSender from "@/api/base/requestSender";

export default {
  name: "cherkizovo-get-cascading-elements-dialog",
  mixins: [paginator],
  components: {Paginator},
  props: {
    elementId: {type: Number},
  },
  data() {
    return {
      loading: false,
      show: false,
      search: null,
      elements: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    showModal() {
      this.search = null;
      this.paginator.page = 1;
      this.show = true;
      this.elements = [];

      this.searchElements();
    },
    searchChanged() {
      this.paginator.page = 1;
      this.searchElements();
    },
    searchElements() {
      this.elements = [];
      this.loading = true;

      requestSender('get', 'cherkizovo-cascading-card-element/get-cascading-users', {
        search: this.search,
        elementId: this.elementId,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
        expand: 'card.user, card',
      })
        .then(({data, paginator}) => {
          this.elements = data.elements;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  }
}
</script>

<style>
  .single-select tr:hover{
    cursor: pointer;
  }
</style>